import { IconButton, InputAdornment, TextField } from '@mui/material';
import VisibilityOffRoundedIcon from '@mui/icons-material/VisibilityOffRounded';
import VisibilityRoundedIcon from '@mui/icons-material/VisibilityRounded';
import { AUTH_ACCENT_MID, authInputSx } from './authFormTheme';

function PasswordField({
  value,
  onChange,
  placeholder = 'Password',
  showPassword = false,
  onTogglePassword,
  ...rest
}) {
  return (
    <TextField
      size="small"
      type={showPassword ? 'text' : 'password'}
      placeholder={placeholder}
      fullWidth
      value={value}
      onChange={onChange}
      sx={authInputSx}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              size="small"
              edge="end"
              aria-label={showPassword ? 'Hide password' : 'Show password'}
              onMouseDown={(e) => e.preventDefault()}
              onClick={onTogglePassword}
              sx={{
                color: AUTH_ACCENT_MID,
                p: 0.75,
                '&:hover': { bgcolor: 'rgba(255,107,107,0.12)' },
              }}
            >
              {showPassword ? (
                <VisibilityRoundedIcon fontSize="medium" />
              ) : (
                <VisibilityOffRoundedIcon fontSize="medium" />
              )}
            </IconButton>
          </InputAdornment>
        ),
      }}
      {...rest}
    />
  );
}

export default PasswordField;
